import { render, staticRenderFns } from "./field-setup.vue?vue&type=template&id=2b43d5f3&scoped=true&"
import script from "./field-setup.vue?vue&type=script&lang=js&"
export * from "./field-setup.vue?vue&type=script&lang=js&"
import style0 from "./field-setup.vue?vue&type=style&index=0&id=2b43d5f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43d5f3",
  null
  
)

export default component.exports